import { render } from "./SenderDomainCheck.vue?vue&type=template&id=4f4b1538"
import script from "./SenderDomainCheck.vue?vue&type=script&lang=js"
export * from "./SenderDomainCheck.vue?vue&type=script&lang=js"

import "./SenderDomainCheck.vue?vue&type=style&index=0&id=4f4b1538&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__